import type {
  CustomerZonePostcodeRemoveRequestType,
  CustomerZonePostcodeRemoveResponseType,
} from "@sellar-io/api-v2/types";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useFirebaseUser } from "../../../useFirebaseUser.shared";
import { useSellarCurrentBusiness } from "../../../useSellarCurrentBusiness.shared";
import { apiV2AssertResponse, apiV2Request } from "../apiV2Request";
import { ServerStateKeys } from "../ServerStateKeys";

export const useCustomerZonePostcodesRemove = (customerZoneId: number) => {
  const queryClient = useQueryClient();
  const { business } = useSellarCurrentBusiness();
  const { user } = useFirebaseUser();

  return useMutation({
    mutationFn: (data: CustomerZonePostcodeRemoveRequestType) =>
      apiV2Request({
        user,
        business,
        method: "delete",
        path: `customer-zones/${customerZoneId}/postcodes`,
        data,
      }).then(
        (data) =>
          apiV2AssertResponse(data)
            .data as CustomerZonePostcodeRemoveResponseType,
      ),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [
          user?.uid,
          business?.id,
          ServerStateKeys.CustomerZonePostcodes,
          customerZoneId,
        ],
      });
    },
  });
};
